module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "connect-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('el-card', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('connections')))]), _vm._v(" "), _c('button', {
    class: {
      'de1': _vm.isDe
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v(_vm._s(_vm.$t('Add Connection')))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": _vm.loadingText
    }
  }, [_c('div', {
    staticClass: "patient-table"
  }, [_c('table', {
    attrs: {
      "id": "patientList"
    }
  }, [_c('tr', {
    staticClass: "header"
  }, [_c('td', [_vm._v(_vm._s(_vm.$t('Name')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('SG'))), _c('br'), _vm._v("(" + _vm._s(_vm.unit) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('basal'))), _c('br'), _vm._v(_vm._s(_vm.$t('basal_unit')))]), _c('td', [_vm._v(_vm._s(_vm.$t('Active Insulin'))), _c('br'), _vm._v(_vm._s(_vm.$t('ins_unit')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Action')))])]), _vm._v(" "), _vm._l((_vm.connections), function(item, index) {
    return _c('tr', {
      class: (index % 2 === 0) ? '' : 'even',
      attrs: {
        "id": index
      }
    }, [_c('td', {
      staticClass: "name",
      attrs: {
        "id": index
      },
      on: {
        "click": _vm.go
      }
    }, [_c('img', {
      staticClass: "portrait",
      attrs: {
        "src": '/api/v2.0/person/' + item.uid + '/portrait'
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "name1"
    }, [_vm._v(_vm._s(item.alias))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.sensor_status.glucose))]), _c('td', [_vm._v(_vm._s(item.pump_status.basalRate))]), _c('td', [_vm._v(_vm._s(item.pump_status.iob))]), _vm._v(" "), _c('td', {
      staticClass: "name",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": _vm.StopFollow
      }
    }, [_vm._v(_vm._s(_vm.$t('Stop following')))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "patientList-block"
  }, [_c('img', {
    class: {
      'click1': !_vm.has_prev
    },
    attrs: {
      "src": require("../../assets/arrow_right.png")
    },
    on: {
      "click": _vm.prevPage
    }
  }), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.page),
      expression: "page"
    }],
    domProps: {
      "value": (_vm.page)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && $event.keyCode !== 13) { return null; }
        _vm.goPage($event)
      },
      "blur": _vm.goPage,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.page = $event.target.value
      }
    }
  }), _vm._v(" of   " + _vm._s(_vm.pages))]), _vm._v(" "), _c('img', {
    class: {
      'click1': !_vm.has_next
    },
    attrs: {
      "src": require("../../assets/arrow_left.png")
    },
    on: {
      "click": _vm.nextPage
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "Hcp-footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n\n           " + _vm._s(_vm.$t('copyright'))), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.showConfirmDialog,
      "size": _vm.dialogSize,
      "id": "dialog-form2",
      "show-close": false,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showConfirmDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('privacy_policy_and_terms_of_use')))])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-content"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('privacy_confirm_text'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [_c('button', {
    staticClass: "deny",
    on: {
      "click": _vm.denyPrivacyConfirm
    }
  }, [_vm._v(_vm._s(_vm.$t('privacy_confirm_disagree')))]), _vm._v(" "), _c('button', {
    staticClass: "agree",
    on: {
      "click": _vm.agreePrivacyConfirm
    }
  }, [_vm._v(_vm._s(_vm.$t('privacy_confirm_accept')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9800eb48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/care-templates/carer-connect.vue
// module id = 1489
// module chunks = 7